
class BaseDB {

  constructor() {
    this.userId = null;
  }

  open(userId) {
    this.userId = userId
  }

  close() {

  }

  buildConversationKey(type, targetId) {
    return type + '-' + targetId;
  }

  async saveConfig(key, val) {
  }

  async findConfig(key) {
    return undefined;
  }

  async deleteConfig(key) {
  }

  async clearLocalCache() {
  }

  async findRecentMessages(convKey, limit) {
    return [];
  }

  async findMessagesBefore(convKey, beforeSeqNo, limit) {
    return [];
  }

  async findMessagesByTypes(convKey, types, beforeSeqNo, limit, keyword) {
    return [];
  }

  async loadAllConversationStates() {
    return [];
  }

  async upsertChatSnapshot(snapshot) {
  }

  async persistChatMutations(payload) {
  }

  async findAllGroups() {
    return [];
  }

  async saveGroups(groups) {
  }

  async saveGroup(group) {
  }

  async syncAllGroups(groups) {
  }

  async findGroupMembers(groupId) {
    return [];
  }

  async saveGroupMembers(groupId, members) {
  }

  async syncGroupMembers(groupId, members) {
  }

  async deleteGroupMembers(groupId) {
  }

  async removeGroupMembersByUserIds(groupId, userIds) {
  }

  async findAllFriendGroups() {
    return [];
  }

  async saveFriendGroups(groups) {
  }

  async saveFriendGroup(group) {
  }

  async deleteFriendGroup(groupId) {
  }

  async syncAllFriendGroups(groups) {
  }
}

export default BaseDB;
